/**
 * Un campo con su etiqueta y su error debajo.
 *
 * El error va ligado al input con `aria-describedby` y el campo se marca con
 * `aria-invalid`: sin eso, quien usa un lector de pantalla oye el campo, no oye que
 * esta mal, y no tiene forma de saber por que el formulario no avanza.
 */

interface Props {
  id: string
  etiqueta: string
  valor: string
  onCambio: (valor: string) => void
  tipo?: 'text' | 'email' | 'number'
  ayuda?: string
  error?: string | undefined
  requerido?: boolean
  autoComplete?: string
  inputMode?: 'text' | 'email' | 'numeric' | 'decimal' | 'tel'
  sufijo?: string
}

export function CampoTexto({
  id,
  etiqueta,
  valor,
  onCambio,
  tipo = 'text',
  ayuda,
  error,
  requerido = false,
  autoComplete,
  inputMode,
  sufijo,
}: Props) {
  const idAyuda = ayuda ? `${id}-ayuda` : undefined
  const idError = error ? `${id}-error` : undefined
  const descrito = [idError, idAyuda].filter(Boolean).join(' ') || undefined

  return (
    <div className="campo">
      <label htmlFor={id}>
        {etiqueta}
        {requerido && <span aria-hidden="true"> *</span>}
      </label>

      <div className={sufijo ? 'entrada-con-sufijo' : undefined}>
        <input
          id={id}
          type={tipo}
          value={valor}
          onChange={(evento) => onCambio(evento.target.value)}
          aria-invalid={error ? true : undefined}
          aria-describedby={descrito}
          autoComplete={autoComplete}
          inputMode={inputMode}
          className={error ? 'con-error' : undefined}
        />
        {sufijo && <span className="sufijo">{sufijo}</span>}
      </div>

      {error && (
        <p className="error" id={idError} role="alert">
          {error}
        </p>
      )}
      {ayuda && !error && (
        <p className="ayuda" id={idAyuda}>
          {ayuda}
        </p>
      )}
    </div>
  )
}
